<div class="page" *ngIf="shown">
    
    <!-- slides -->
    <div class="page__contents">
        <ng-content></ng-content>
    </div>
    
</div>
